/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Error_GenericInputs */

const en_us2_profile_editors_error_generic = /** @type {(inputs: Profile_Editors_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't save. Check your connection and try again.`)
};

const pt_br2_profile_editors_error_generic = /** @type {(inputs: Profile_Editors_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não deu para salvar. Confira sua conexão e tente de novo.`)
};

const es_419_profile_editors_error_generic = /** @type {(inputs: Profile_Editors_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo guardar. Revisa tu conexión e inténtalo de nuevo.`)
};

const pt_pt2_profile_editors_error_generic = /** @type {(inputs: Profile_Editors_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível guardar. Verifica a tua ligação e tenta outra vez.`)
};

const fr_fr2_profile_editors_error_generic = /** @type {(inputs: Profile_Editors_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible d'enregistrer. Vérifie ta connexion et réessaie.`)
};

const de_de2_profile_editors_error_generic = /** @type {(inputs: Profile_Editors_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speichern fehlgeschlagen. Prüf deine Verbindung und versuch es noch mal.`)
};

const it_it2_profile_editors_error_generic = /** @type {(inputs: Profile_Editors_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile salvare. Controlla la connessione e riprova.`)
};

/**
* | output |
* | --- |
* | "Couldn't save. Check your connection and try again." |
*
* @param {Profile_Editors_Error_GenericInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_error_generic = /** @type {((inputs?: Profile_Editors_Error_GenericInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Error_GenericInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_error_generic(inputs)
	if (locale === "es-419") return es_419_profile_editors_error_generic(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_error_generic(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_error_generic(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_error_generic(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_error_generic(inputs)
	return en_us2_profile_editors_error_generic(inputs)
});
export { profile_editors_error_generic as "profile-editors.error_generic" }